import Axios from 'axios';
import ApiUtils from '../utils/api_utils';

const API_URL = `https://${ApiUtils.authority}`;
const SnapReceiptSM = {
  state: {
    listReceipt: [],
    dataReceipt: [],
    categories: [],
    products: [],
    setting: null,
  },
  reducers: {
    setNewsState(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: (dispatch) => ({
    async getData(status = 'on_progress', rootState, ordering = '-created') {
      dispatch.SnapReceiptSM.setNewsState({
        ...rootState.SnapReceiptSM,
        listReceipt: [],
      });
      let result;
      await Axios.get(
        `${API_URL}/snap_receipt/api/mobile/?status=${status}&ordering=${ordering}`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          dispatch.SnapReceiptSM.setNewsState({
            ...rootState.SnapReceiptSM,
            listReceipt: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: 'success',
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getDataById(id, rootState) {
      let result;
      await Axios.get(`${API_URL}/snap_receipt/api/mobile/${id}/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.SnapReceiptSM.setNewsState({
            ...rootState.SnapReceiptSM,
            dataReceipt: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: 'success',
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async postReceipt(payload, rootState) {
      let result;
      await Axios.post(`${API_URL}/snap_receipt/api/mobile/`, payload, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          result = {
            data: response.data,
            status: 200,
            message: 'success',
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getCategory(_id, rootState) {
      let result;
      await Axios.get(`${API_URL}/snap_receipt/api/mobile/category/dropdown/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.SnapReceiptSM.setNewsState({
            ...rootState.SnapReceiptSM,
            category: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: 'success',
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getProduct(catId, rootState) {
      let result;
      await Axios.get(
        `${API_URL}/snap_receipt/api/mobile/product/dropdown/?category_id=${catId}`,
        {
          headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
          withCredentials: false,
        }
      )
        .then((response) => {
          dispatch.SnapReceiptSM.setNewsState({
            ...rootState.SnapReceiptSM,
            products: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: 'success',
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
    async getRetrieveSetting(_id, rootState) {
      let result;
      await Axios.get(`${API_URL}/snap_receipt/api/mobile/setting/`, {
        headers: ApiUtils.getHeader({ token: rootState.LoginSM.token }),
        withCredentials: false,
      })
        .then((response) => {
          dispatch.SnapReceiptSM.setNewsState({
            ...rootState.SnapReceiptSM,
            setting: response.data,
          });
          result = {
            data: response.data,
            status: 200,
            message: 'success',
          };
        })
        .catch((error) => {
          result = {
            data: [],
            status: 400,
            message: error.response.data,
          };
        });

      return result;
    },
  }),
};

export default SnapReceiptSM;
